import classnames from 'classnames';
import * as React from 'react';
import { Img } from 'react-image';

const AVATAR_BASE_PATH = 'assets/Avatars/vv/';

export function buildAvatarLinkFromName(name) {
	return `${AVATAR_BASE_PATH}${name}`;
}

const Avatar = ({ avatar, width, height, className, ...rest }) => {
	const avatarURL = React.useMemo(() => {
		if (!avatar) {
			return null;
		}

		if (avatar.indexOf('/') > -1) {
			return avatar; //Avatar has a slash, assume it's a URL
		}

		return `${buildAvatarLinkFromName(avatar)}`;

	}, [avatar]);

	return (
		<Img
			height={height ?? 93}
			width={width ?? 93}
			{...rest}
			className={classnames('gamerTagImage', className)}
			src={avatarURL}
		/>
	);
};

export default React.memo(Avatar);
